import React, { useState, useEffect, useRef } from "react";
import NavBar from "./NavBar";
import "../CSS/HomePage.css"
import 'bootstrap/dist/css/bootstrap.min.css';
import banner3 from "../Assets/Images/Banner/thank2.jpg"
import { useInView } from "react-intersection-observer";
import whatsappIcon1 from "../Assets/Images/Tech/Icons/whatsapp.svg"
import { Helmet } from "react-helmet";
import confetti from "canvas-confetti";

const HomePage = () => {

    const [isHovered, setIsHovered] = useState(false);
    const [hovered, setHovered] = useState(null);
    const { ref, inView } = useInView({ triggerOnce: true, threshold: 0.5 });

    const handleClick = () => {
        const end = Date.now() + 3 * 1000; // 3 seconds
        const colors = ["#a786ff", "#fd8bbc", "#eca184", "#f8deb1"];

        const frame = () => {
            if (Date.now() > end) return;

            confetti({
                particleCount: 2,
                angle: 60,
                spread: 55,
                startVelocity: 60,
                origin: { x: 0, y: 0.5 },
                colors: colors,
            });
            confetti({
                particleCount: 2,
                angle: 120,
                spread: 55,
                startVelocity: 60,
                origin: { x: 1, y: 0.5 },
                colors: colors,
            });

            requestAnimationFrame(frame);
        };

        frame();
    }
    useEffect = () => {
        handleClick()
    }
    return (
        <div>
            <Helmet>
                <title>Anglofone Website</title>
                <meta name="description" content="AngloFone is the best online educational firm that teaches people in all walks of life to speak English in a way that eases the learning process." />
                <link href="https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@400;500;700&display=swap" rel="stylesheet" />
                <script async src="https://www.googletagmanager.com/gtag/js?id=G-ZD6E1Q4R6E"></script>
                <script>
                    {`
                        window.dataLayer = window.dataLayer || [];
                        function gtag(){dataLayer.push(arguments);}
                        gtag('js', new Date());
                        gtag('config', 'G-ZD6E1Q4R6E');
                    `}
                </script>
            </Helmet>

            {/* Google Tag Manager noscript for fallback */}
            <noscript>
                <iframe
                    src="https://www.googletagmanager.com/ns.html?id=GTM-5DKHZLSQ"
                    height="0"
                    width="0"
                    style={{ display: "none", visibility: "hidden" }}
                    title="GTM"
                />
            </noscript>

            <NavBar navIndex="Home" />

            <div className="col-md-12" >
                <div className="banner-container-landing">
                    <div className="image-container-landing">
                        <img src={banner3} className="img-fluid d-block mx-auto" alt="Banner" />

                        {/* Centered text over the image */}
                        <div className="centered-text">
                            <h1 style={{fontWeight:"900",color:"red" }}  >Thank You!</h1>
                           <h5 style={{ fontWeight:"500" }}  > Congratulations 🎉
 
You've taken the first step towards your language learning journey at Anglofone 

Our team will message you on WhatsApp soon. </h5>                       </div>
                        <div className="modal fade" id="customModalinHome" tabIndex="-1" aria-hidden="true" >
                        </div>
                    </div>
                </div>
                <div className="row" style={{ position: "absolute", display: "flex", justifyContent: "space-between", marginLeft: "20px", marginRight: "20px" }}>
                    <div className="col-md-8" style={{ marginTop: "-390px" }} >
                    </div>
                </div>
            </div>
            <div>
            </div>
        </div >
    )
}
export default HomePage;